import { REMOVE_MULTIPLE_OPTIMISTIC_TROLLEY_ITEMS } from './types';

export default trolleyItems => ({
  type: REMOVE_MULTIPLE_OPTIMISTIC_TROLLEY_ITEMS,
  trolleyItems,
});
